module.exports = __webpack_public_path__ + "img/new-task.45ca355f.png";